import * as yup from "yup";

interface RCIIFormValidationSchemaProps {
  languageSpecialization: boolean;
}

const RCIIFormValidationSchema = ({languageSpecialization}: RCIIFormValidationSchemaProps) => {
let schema = yup.object().shape({
    title: yup.string().max(60, 'Title cannot exceed 60 characters').required("Title is required"),
    ageGroup: yup.string().required("Age Group is required"),
    intendedGoals: yup.string().required("Intended Goal summary is required"),
    materials: yup.string().required("Material details is required"),
    process: yup.string().required("Teaching Strategies is required"),
    development: yup.string().required("Development Experience is required"),
    titleBilingual: yup.string(),
    intendedGoalsBiligual: yup.string(),
    materialsBiligual: yup.string(),
    processBiligual: yup.string(),
    developmentBiligual: yup.string()
});
const secondLanguageFields = {
    titleBilingual: yup.string().max(60, 'Title in your second language cannot exceed 60 characters').required("Title in second language is required"),
    intendedGoalsBiligual: yup.string().required("Intended Goal in second language is required"),
    materialsBiligual: yup.string().required("Material details in second language is required"),
    processBiligual: yup.string().required("Teaching Strategies in second language is required"),
    developmentBiligual: yup.string().required("Development Experience in second language is required")
}


if (languageSpecialization) {
    schema = schema.shape(secondLanguageFields);
  }

  return schema;
}
export default RCIIFormValidationSchema;
